import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "invite-officers-and-roles",
  courseId: "for-agency-admins",
  order: 2,
  title: "Invite officers",
  subtitle: "And assign roles",
  summary:
    "Invite officers by email on the Officers tab, assign the Officer or Records role, and remove people when they leave.",
  learn: [
    "Send and resend invitations",
    "Choose between the Officer and Records roles",
    "Know where add-on seats are assigned",
  ],
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "paragraph",
      text: "Who can use the app and what they can see is managed on the Officers tab. Roles are set per person. Add-on seats sit on top of the role rather than replacing it.",
    },
    {
      type: "steps",
      items: [
        "On the **Officers** tab click **Invite Officers**.",
        "Paste addresses into \"Add emails...\" and send.",
        "For a pending invitation, click **Resend**. Click **Remove** to withdraw an invite or deactivate an officer.",
        "Set each officer's Role: Officer or Records.",
      ],
    },
    {
      type: "paragraph",
      text: "Each invite uses a seat when accepted. Officer sees their own cases only. Records sees every case in the agency (read and export), with an **All officers** filter in their list.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Who gets Records",
      text: "Use it for the records unit and supervisors who need to pull any report. It does not let them edit another officer's narrative.",
    },
    {
      type: "callout",
      tone: "note",
      title: "SSO departments",
      text: "If single sign-on is configured, invites send officers to the login page and straight to your identity provider. Accounts are created on first sign-in with no password. An officer who has an invite but sees a locked email on a sign-up form should use the login link instead.",
    },
    {
      type: "paragraph",
      text: "Investigator and footage seats are assigned from the same officer table, on top of the role you set here. Buying, assigning, and revoking them is covered in the **Seats and hours** lesson.",
    },
  ],
  related: ["seats-and-hour-packs", "single-sign-on", "the-agency-dashboard"],
};

export default lesson;
